export default "/build/images/aero-score-a.c76e6ad6.png";